import React, { useState } from "react";
import { toast } from "sonner";
import api from "../../lib/api";

export default function SupportInbox({ tickets, onReload }) {
  const [activeTicket, setActiveTicket] = useState(null);
  const [reply, setReply] = useState("");

  const sendReply = async () => {
    if (!reply.trim() || !activeTicket) return;
    try {
      const { data } = await api.post(`/support/tickets/${activeTicket.ticket_id}/reply`, { text: reply });
      setActiveTicket(data);
      setReply("");
      onReload?.();
    } catch (err) {
      // eslint-disable-next-line no-console
      console.warn("[support] reply failed:", err);
      toast.error("Reply failed");
    }
  };

  const resolve = async (id) => {
    try {
      await api.post(`/support/tickets/${id}/resolve`);
      toast.success("Ticket resolved");
      if (activeTicket?.ticket_id === id) setActiveTicket(null);
      onReload?.();
    } catch (err) {
      // eslint-disable-next-line no-console
      console.warn("[support] resolve failed:", err);
      toast.error("Resolve failed");
    }
  };

  return (
    <div className="grid md:grid-cols-[300px_1fr] gap-4" data-testid="admin-support-inbox">
      <div className="space-y-2 max-h-[70vh] overflow-y-auto">
        {tickets.map((t) => (
          <button
            key={t.ticket_id}
            onClick={() => setActiveTicket(t)}
            data-testid="admin-ticket-item"
            className={`w-full card-surface p-3 text-left hover:bg-[#F9F7F3] transition-all ${activeTicket?.ticket_id === t.ticket_id ? "border-[#A94438]" : ""}`}
          >
            <p className="font-bold text-sm truncate">{t.subject}</p>
            <p className="text-xs text-[#5C5C54]">{t.user_name} · {t.status}</p>
          </button>
        ))}
        {tickets.length === 0 && <p className="text-xs text-[#5C5C54] text-center py-8">No tickets.</p>}
      </div>

      <div className="card-surface p-5">
        {activeTicket ? (
          <>
            <div className="flex justify-between items-start mb-4">
              <div>
                <h3 className="font-heading font-bold">{activeTicket.subject}</h3>
                <p className="text-xs text-[#5C5C54]">{activeTicket.user_name} · {activeTicket.status}</p>
              </div>
              {activeTicket.status !== "resolved" && (
                <button onClick={() => resolve(activeTicket.ticket_id)} className="btn-secondary text-xs">Mark resolved</button>
              )}
            </div>
            <div className="space-y-2 max-h-80 overflow-y-auto mb-4 p-3 bg-[#F9F7F3] rounded-xl">
              {activeTicket.messages.map((m, i) => (
                <div
                  key={`${m.at || ""}-${i}`}
                  className={`max-w-[80%] px-3 py-2 rounded-xl text-sm ${m.sender === "support" ? "bg-[#A94438] text-white ml-auto" : "bg-white border border-[#E5E2D9]"}`}
                >
                  {m.text}
                </div>
              ))}
            </div>
            <div className="flex gap-2">
              <input
                data-testid="admin-reply-input"
                value={reply}
                onChange={(e) => setReply(e.target.value)}
                onKeyDown={(e) => e.key === "Enter" && sendReply()}
                placeholder="Reply as support..."
                className="input-field flex-1"
              />
              <button data-testid="admin-reply-btn" onClick={sendReply} className="btn-primary text-xs">Send</button>
            </div>
          </>
        ) : (
          <p className="text-sm text-[#5C5C54] text-center py-12">Select a ticket to view the conversation.</p>
        )}
      </div>
    </div>
  );
}
